import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import { useLocation } from 'react-router-dom';
import { isWebviewRenderType } from 'Utils/webviewMode';

const AnnouncementsDetail = loadable(() => pMinDelay(import('./AnnouncementsDetail'), 300), {
  fallback: <Loading />
});

const AsyncAnnouncementsDetail = props => {
  const location = useLocation();
  const pathname = location.pathname;
  const pathSegments = pathname.split('/');
  const detail = pathSegments[2];
  const isWebview = isWebviewRenderType(location.search);

  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: detail !== null && isWebview && (props.userAgent.device?.type === 'mobile') ? 'none' : 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`
      }
    }
  };

  return  (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <AnnouncementsDetail { ...props } helmet={ pageConfig.helmet } />
    </ApplicationLayout>
  );
};

AsyncAnnouncementsDetail.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncAnnouncementsDetail;
